/**
 * LOI edit toolbar glyphs — Figma Brushfire Web Dev Handoff V.1
 * Committed SVGs under `src/assets/` (stable; no MCP raster URLs).
 *
 * - Reset: node 4255:5213 (`pencil-line 10`, #E58252)
 * - Save: node 4255:5212 (`pencil-line 9`, B.Primary 1 #008CD0 — `theme.palette.primary.main`)
 * - Delete: node 4255:5214 (`delete-bin-line 1`, B.Error #EF4444)
 */
import loiEditResetToolbarIconSrc from '@/assets/loi-edit-reset-line.svg'
import loiEditSaveToolbarIconSrc from '@/assets/loi-edit-save-line.svg'
import loiEditDeleteToolbarIconSrc from '@/assets/delete-bin-line 1.svg'

export {
  loiEditResetToolbarIconSrc,
  loiEditSaveToolbarIconSrc,
  loiEditDeleteToolbarIconSrc,
}

export const loiEditToolbarIconImgSx = {
  width: 17,
  height: 17,
  display: 'block' as const,
  objectFit: 'contain' as const,
}

/** Figma toolbar icon hit target — glyph in compact control. */
export const loiEditToolbarIconButtonSx = {
  p: '4px',
  width: 25,
  height: 25,
  '&.Mui-disabled': {
    opacity: 1,
  },
  '&.Mui-disabled img': {
    opacity: 0.38,
    filter: 'grayscale(1)',
  },
}
